import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { AutoRenewPanel } from '../AutoRenewPanel/AutoRenewPanel';
import { AutoRenewalCancelledBanner } from '../AutoRenewalCancelledBanner/AutoRenewalCancelledBanner';
import { type TicketStatusInput, isHuntCancelledByUser, isHuntEndedByJackpotWin } from '../utils/getTicketStatuses/getTicketStatuses';

type PaymentSummaryProps = ComponentProps<'div'> &
  TicketStatusInput & {
    hasRenewal: boolean;
    lastDrawingDate?: string;
    activeSince?: string;
    onCancelClick: () => void;
  };

function shouldShowRenewalCancelledBanner(input: TicketStatusInput): boolean {
  if (input.renewType === 'Subscription') return !!input.cancelReceiptAt;

  return isHuntCancelledByUser(input) || isHuntEndedByJackpotWin(input);
}

function PaymentSummary({ hasRenewal, renewType, cancelReceiptAt, ticketState, lastDrawingDate, activeSince, onCancelClick, className, ...props }: PaymentSummaryProps) {
  if (!hasRenewal) return null;

  const showCancelledBanner = shouldShowRenewalCancelledBanner({ renewType, cancelReceiptAt, ticketState });
  const showActivePanel = !showCancelledBanner && activeSince;

  if (!showCancelledBanner && !showActivePanel) return null;

  return (
    <div className={twMerge('ll-container-inner flex flex-col gap-4', className)} {...props}>
      {showCancelledBanner ? (
        <AutoRenewalCancelledBanner renewType={renewType} cancelReceiptAt={cancelReceiptAt} ticketState={ticketState} lastDrawingDate={lastDrawingDate} />
      ) : (
        <AutoRenewPanel
          activeSince={new Date(activeSince!)}
          onCancelClick={onCancelClick}
          isJackpotHunt={renewType === 'Hunt'}
          data-track-container="Renew"
          data-track-type="Auto"
        />
      )}
    </div>
  );
}

export { PaymentSummary };
